const UPDATES = [
  {
    date: '08-01',
    title: '暑期档热片《星际穿越2》高清上线',
    desc: '科幻巨制独家高清版本，4K画质震撼来袭',
    tag: '新片上线',
  },
  {
    date: '07-31',
    title: '热门韩剧《命运之轮》全集更新完毕',
    desc: '16集全高清资源已同步，一口气追完不等待',
    tag: '全集更新',
  },
  {
    date: '07-30',
    title: '国产悬疑剧《暗夜追踪》第24集更新',
    desc: '本周剧情大反转，烧脑程度再升级',
    tag: '剧集更新',
  },
  {
    date: '07-29',
    title: '院线动画《龙之秘境》高清版独家首发',
    desc: '视觉特效拉满，国漫年度力作不容错过',
    tag: '独家首发',
  },
  {
    date: '07-28',
    title: '经典港片修复系列上线，画质全面提升',
    desc: '周星驰、成龙经典作品高清修复版陆续上线',
    tag: '经典修复',
  },
  {
    date: '07-27',
    title: '平台服务器全面升级，加载速度提升40%',
    desc: '全新CDN加速节点部署完成，观影更流畅',
    tag: '平台动态',
  },
  {
    date: '07-26',
    title: '综艺《欢乐星期六》最新一期已更新',
    desc: '明星嘉宾阵容豪华，笑料不断精彩连连',
    tag: '综艺更新',
  },
  {
    date: '07-25',
    title: '日本动漫夏季新番专题页面上线',
    desc: '本季热门番剧一网打尽，追番必看指南',
    tag: '专题上线',
  },
  {
    date: '07-24',
    title: '电影《深海救援》HD高清资源全网首发',
    desc: '灾难大片紧张刺激，口碑爆棚不容错过',
    tag: '新片上线',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">最新更新</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            实时追踪站内最新影视资源动态
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-300/50"></div>
          <div className="space-y-5 md:space-y-6">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-3 md:left-[22px] top-1.5 w-[9px] h-[9px] rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex-shrink-0 w-14 md:w-16 text-right">
                  <span className="text-xs font-bold text-primary-400 whitespace-nowrap">{item.date}</span>
                </div>
                <div className="flex-1 min-w-0 pb-5 md:pb-6 border-b border-background-300/20">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-100">{item.title}</h3>
                    <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500/15 text-accent-400 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}